"use client"

import { Fragment } from 'react'
import Carousel from "@/components/common/Carousel"
import Title from "@/components/common/Typography/Title"
import { TypeCategory, TypeStoreDetail } from "@/lib/redux/features/store/type"
import { Button, Col, Row, theme } from "antd"
import { checkIfShownStoreName } from '@/utils/app/checkIfShownStoreName'
import { useIsDesktop } from '@/hooks/app/useIsDesktop'

const CategoriesNavigation = ({ categories, store }: { categories: TypeCategory[], store: TypeStoreDetail }) => {
  const isDesktop = useIsDesktop()
  const hiddenStoreName = !checkIfShownStoreName(store)
  const token = theme.useToken().token
  
  if (`${store.shown_categories}` !== '2') {
    return <Fragment />
  }

  return (
    <Col
      span={24}
      style={{
        boxShadow: token.boxShadow,
        zIndex: 1,
        backdropFilter: 'blur(100px)'
      }}
      className={`home__navigation${hiddenStoreName || `${store.shown_categories}` === '2' ? ' hidden--store_name': ''}`}
    >
      <Carousel
        options={{
          prevNextButtons: false,
          pageDots: false,
          contain: true,
          draggable: true,
        }}
      >
        {categories.map(cate => {
          return (
            <Row key={cate.id} style={{ paddingInline: '0.5rem' }}>
              <Col>
                <Button
                  aria-label={`Scroll to ${cate.category_name} section`}
                  htmlType="button"
                  type='text'
                  size='large'
                  style={{ fontSize: '2rem', fontWeight: 'bold', maxHeight: 'unset', height: '4rem', borderRadius: 0 }}
                  onClick={(e: any) => {
                    const target = document.querySelector(`#category__section--${cate.id}`)
                    if (!!target) {
                      const elementPosition = target.getBoundingClientRect().top
                      const offsetPosition = elementPosition + window.pageYOffset - target.clientHeight - e.target.clientHeight;
                      window.scrollTo({
                        top: offsetPosition,
                        behavior: "smooth"
                      });
                    }
                  }}
                >
                  {cate.category_name}
                </Button>
              </Col>
            </Row>
          )
        })}
      </Carousel>
    </Col>
  )
}

export default CategoriesNavigation